<!-- =========================================================================================
  File Name: ChatgroupEdit.vue
  Description: Chatgroup Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.header-custome{margin-bottom: 15px; padding-left: 2px;}
.attendee-form-wrap {padding: 0 100px;}
.chat-group-list ul li p{padding-left: 9px; width: 50%;}
@media screen and (min-width:1367px) and (max-width: 1440px){
.attendee-form-wrap {
    padding: 0 80px;
}
}
@media screen and (max-width:1366px) {
.attendee-form-wrap {
    padding: 0 70px;
}
}
</style>
<template>
  <div id="page-user-edit" >
    <div class="header-custome">
      <h3>Edit Chat Group</h3>
    </div>
    <vx-card class="attendee-form-wrap" v-if="chatgroup_data">
      <div class="vx-row mb-10">
        <div class="vx-col md:w-6/12 w-full flex small-screen-adjust" style="align-items: center;">
          <div class="group-icon-upload-box mr-5">
            <div class="icon-wrap">
              <img :src="imgSrc" v-if="imgSrc" style="width: 100%;" />
              <img src="../../assets/image.svg" style="width: 100%;" v-else />
            </div>
          </div>
          <div class="upload-file-area">
            <input
                  id="uploadAvatar"
                  type="file"
                  @change="update_avatar($event, '200x100', true)"
                  accept="image/*"
                />
            <span>Drag &amp; drop or click to add group icon</span>
            <p>Image should be in 1:1 format in PNG, JPG. Max 2 MB</p>
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full">
          <div class="custom-head-wrap border-none">
              <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
              <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->
              <input
                type="text"
                name="Title"   
                v-model="chatgroup_data.roomName"        
                v-validate="'required'"
                class="w-full" id="" value="" placeholder="Group Chat Name*"/>
                <span class="text-danger text-sm" v-show="errors.has('Title')">This field is required</span>
                <input
                type="text"
                v-model="chatgroup_data.roomDescription"
                class="w-full session-desc" id="" value="" placeholder="Group Chat Description (Optional)"/>
                <label>Group Admin</label>
                <v-select
                  placeholder="select user"
                  :options="attendessList"
                  v-model="chatgroup_data.groupAdminUserId"
                  :reduce="item => item.AttendeeId" 
                  label="Email"
                />
          </div>
        </div>
        
      </div>
      <div class="select-group-wrap">
        <div class="custom-head-wrap mb-5">
          <h2 class="cms-custom-heading">
           Audience
          </h2>
        </div>
        <vs-radio color="#1f73b7" v-model="SelectdType" vs-value="attendees">Select Attendees</vs-radio>
        <div class="select-group-hld mt-5">
          <div class="group-list-header" >
            <p>Attendee Name</p>
            <p>Email id</p>
          </div>
          <div class="chat-group-list" v-if="SelectdType=='attendees'">
            <div class="search-chat-group-list mb-5">
              <div class="grouplist-search-box">
                <vs-input class="inputx w-full" placeholder="Search Attendees" @keyup="searchAttendee" v-model="attendeeName" />
                <span class="search-icon"><feather-icon icon="SearchIcon" class="mr-2" size="40px"/></span>
              </div>
              <vs-button class="ml-3" color="rgb(76, 139, 246)" type="filled">SEARCH</vs-button>
            </div>
            <ul>
              <li class="mb-2" v-for="attendee in attendee_search_list">
                <vs-checkbox color="#1f73b7" v-model="chatgroup_data.userIdList" :vs-value="attendee.AttendeeId">{{attendee.FirstName}} {{attendee.LastName}}</vs-checkbox>
                <p>{{attendee.Email}}</p>
              </li>              
            </ul>
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="mt-2" @click="$router.push('/event/chat')"
            >Back To List</vs-button
          >          
          <vs-button
            class="ml-auto mt-2"
            @click="before_save()"
            color="success"
            >Save & Exit</vs-button
          >          
        </div>
      </div>
    </div>

    </vx-card>   

    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>

  </div>
</template>

<script>
import vSelect from "vue-select";
import ls from "@/common/localStorage"
// Store Module
import moduleChatgroupManagement from "@/store/chatgroup-management/moduleChatgroupManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";

import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
var cn = ls.getSessionEventCollectionName();
var vm;
export default {
  components: {
    "v-select": vSelect,
    PhotowallResizeComponent
  },
  data() {
    return {
      imgSrc: null,
      chatgroup_data: null,
      chatgroup_not_found: false,
      attendessList: [],
      attendeeName: null,
      SelectdType: 'attendees',
      attendee_search_list: [],
      after_selected_attendees: [],
      imageRatio: 2 / 1,
      cropImageUrl: null,
      popupCropper: false,
      resetCropper: 0,
      displayImageRatio: "2 / 1",
      uploadedFile: null,
    };
  },
  watch: {
  },
  methods: {
    fetch_chatgroup_data() {
      if(this.$route.params.id){
      this.$store
        .dispatch("chatgroupManagement/fetchChatgroup", this.$route.params.id)
        .then(res => {
          this.chatgroup_data = {
              roomId: res.data.id ? res.data.id : null,
              roomName: res.data.name ? res.data.name : null,
              roomIconUrl: res.data.iconUrl ? res.data.iconUrl : null,
              groupAdminUserId: res.data.groupAdminUserId ? res.data.groupAdminUserId : null,
              userIdList: res.data.userIdList ? res.data.userIdList : [],
              roomDescription: res.data.description ? res.data.description : null,
          }
          this.imgSrc = res.data.iconUrl ? res.data.iconUrl : null;
        })
        .catch(err => {
        });
      }
    },
    searchAttendee() {
      let attendeeName = this.attendeeName.trim().toLowerCase();
      if (attendeeName) {
        this.attendee_search_list = this.after_selected_attendees.filter((row) => {
          if (
            String(row.FirstName).toLowerCase().includes(attendeeName) ||
            String(row.LastName).toLowerCase().includes(attendeeName) ||
            String(row.Email).toLowerCase().includes(attendeeName)
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        this.attendee_search_list = this.after_selected_attendees;
      }
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        for (let i = 0; i < res.length; i++) {
          if(!res[i].HideInList){
            this.attendessList.push({
              AttendeeId: res[i].AttendeeId,
              Company: res[i].Company,
              Designation: res[i].Designation,
              Email: res[i].Email,
              FirstName: res[i].FirstName,
              LastName: res[i].LastName,
              Name: res[i].Name,
              Phone: res[i].Phone,
              ProfilePictureURL: res[i].ProfilePictureURL,
            });
          }
        }
        this.attendee_search_list = this.after_selected_attendees = this.attendessList
      });
    },
    croppedImagePath(blob) {
      //this.imgSrc = blob;
      this.popupCropper = false;
      if (this.uploadedFile)
        vm.uploadImage(blob, `${cn}/Chatgroup/LogoImage/`, this.uploadedFile);
    },
    update_avatar(input, fileWH, checkRatio = false) {
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.popupCropper = true;
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("chatgroupManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.chatgroup_data.roomIconUrl = res.data[0].value.url;
            this.imgSrc = res.data[0].value.url;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Session",
            text: "Something went wrong!",
          });
        });
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          resolve(result);
          if (result) vm.formSubmitted();
        });
      });
    },
    formSubmitted() {      
      if(this.chatgroup_data.groupAdminUserId && this.chatgroup_data.userIdList.indexOf(this.chatgroup_data.groupAdminUserId) === -1)
        this.chatgroup_data.userIdList.push(this.chatgroup_data.groupAdminUserId)
      if(this.chatgroup_data.userIdList.length > 2){
        this.$vs.loading();
        this.$store
          .dispatch("chatgroupManagement/updateChatgroup", {
            data: this.chatgroup_data,
          })
          .then((res) => {
            //alert(res.message)

            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                text: "Chat Group updated successfully.",
              });
              this.$router.push('/event/chat');
            }
            else{
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: "Chat Group not updated!",
              });
            }
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      }
      else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Group Chat",
          text: "Atleast 3 users needed!",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
  },
  created() {
    vm = this;
    // Register Module UserManagement Module
    if (!moduleChatgroupManagement.isRegistered) {
      this.$store.registerModule("chatgroupManagement", moduleChatgroupManagement);
      moduleChatgroupManagement.isRegistered = true;
    }
    this.fetch_chatgroup_data();
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    this.getAttendees();
  }
};
</script>